import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { SvgIconProps } from './SvgIcon.types';

export const TruckIcon = memo(({ className }: SvgIconProps) => {
  return (
    <SvgIcon
      className={className}
      width="214"
      height="135"
      viewBox="0 0 214 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M167.7 26.2001H143.1V27.5001C143.1 18.6001 135.9 11.4001 127 11.4001H16.5C7.60002 11.4001 0.400024 18.6001 0.400024 27.5001V100.5C0.400024 109.4 7.60002 116.6 16.5 116.6H27H27.4C29.2 127 38.3 134.9 49.3 134.9C60.3 134.9 69.3 127.1 71.2 116.6H72.1H125.9L126.2 116.1C127.9 126.8 137 134.8 148.1 134.8C159.1 134.8 168.1 127 170 116.5H193.5C198.9 116.5 203.9 112.1 203.9 106.1V62.1001C203.7 42.4001 187.9 26.2001 167.7 26.2001Z"
        fill="#EED0AD"
      />
      <path d="M159.6 53.3H200.2" stroke="#E57C00" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M177.6 106.8H201.2C206.6 106.8 211.6 102.4 211.6 96.4001V52.4001C211.6 32.6001 195.8 16.3 175.5 16.3H150.9"
        stroke="#E57C00"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M34.9 106.8H24.4C15.5 106.8 8.30005 99.6001 8.30005 90.7001V17.7001C8.30005 8.8001 15.5 1.6001 24.4 1.6001H134.9C143.8 1.6001 151 8.8001 151 17.7001V80.2001"
        stroke="#E57C00"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M133.7 106.8H79.8" stroke="#E57C00" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M155.9 125.1C168.2 125.1 178.1 115.2 178.1 102.9C178.1 90.6002 168.2 80.7002 155.9 80.7002C143.6 80.7002 133.7 90.6002 133.7 102.9C133.7 115.2 143.5 125.1 155.9 125.1Z"
        stroke="#E57C00"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M57.1 125.1C69.4 125.1 79.3 115.2 79.3 102.9C79.3 90.6002 69.4 80.7002 57.1 80.7002C44.8 80.7002 34.9 90.6002 34.9 102.9C34.9 115.2 44.8 125.1 57.1 125.1Z"
        stroke="#E57C00"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M63.9 102.9C63.9 106.6 60.9001 109.7 57.1001 109.7C53.4001 109.7 50.3 106.7 50.3 102.9C50.3 99.2001 53.3001 96.1001 57.1001 96.1001"
        stroke="#E57C00"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M126.4 90.6001H106.3H86.2001H106.3H126.4Z"
        stroke="#226937"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3 90.6001H14.4"
        stroke="#226937"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M162.7 102.9C162.7 106.6 159.7 109.7 155.9 109.7C152.1 109.7 149.1 106.7 149.1 102.9C149.1 99.2001 152.1 96.1001 155.9 96.1001"
        stroke="#E57C00"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
});
